import player from './player'

const setCameraLookAt = function (eye, target, duration) {
  let api = player.getApi()
  if (duration === null) duration = 1

  return new Promise ((resolve, reject) => {
    if (api) {
      api.setCameraLookAt(eye, target, duration, function () {
        resolve()
      })
    } else reject()
  })
}

const setFov = function (fov) {
  let api = player.getApi()
  if (fov === null) fov = 45

  return new Promise ((resolve, reject) => {
    if (api) {
      api.setFov(fov, function () {
        resolve()
      })
    } else reject()
  })
}

const getCamera = function () {
  let api = player.getApi()

  return new Promise ((resolve, reject) => {
    if (api) {
      api.getCameraLookAt(function (err, camera) {
        if (err) reject(err)
        resolve(camera)
      })
    } else reject()
  })

}

const getFov = function () {
  let api = player.getApi()

  return new Promise ((resolve, reject) => {
    if (api) {
      api.getFov(function (err, angle) {
        if (err) reject(err)
        resolve(angle)
      })
    } else reject()
  })

}

export default { setCameraLookAt, getCamera, setFov, getFov }
